import { TGroupedPoints } from '../../../grouping/group-model';

export function collectGroupIds(groupedPoints: TGroupedPoints[]): string[] {
  return groupedPoints.flatMap((group) => [
    ...(group.id ? [group.id] : []),
    ...collectGroupIds(group.group ?? []),
  ]);
}
